angular.module('pl-shared')

  .directive('radioQuestionView', function(choiceQuestionView) {

    return choiceQuestionView

  })
